/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureDiskRestoreResult {
  /**
  * ID of the restored Azure disk.
  */
  'diskId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "diskId",
      "baseName": "diskId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureDiskRestoreResult.attributeTypeMap;
  }

  public constructor() {
  }
}

